module.exports = __webpack_public_path__ + "cc760b12acb76abcfad734e053b33b6e.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/movie-icons/04_icon_project_animation.gif
// module id = 689
// module chunks = 0